import type { DemandCalculation } from './types/DemandCalculation';
import type { DemandFleetCompany } from './types/DemandFleetCompany';
import type { DemandProductCategoryOption } from './types/DemandProductCategoryOption';

interface CalculatedDemandScope {
    categories: DemandProductCategoryOption[];
    companies: DemandFleetCompany[];
}

export const getCalculatedDemandScope = (
    calculation: DemandCalculation | undefined,
    companies: DemandFleetCompany[],
    categories: DemandProductCategoryOption[],
    companyVolumes?: Record<string, number>
): CalculatedDemandScope => {
    return {
        companies: companies.map((company) => ({
            ...company,
            historicalVolume: companyVolumes?.[company.id],
            vessels: company.vessels.map((vessel) => ({
                ...vessel,
                historicalVolume: calculation?.vesselVolumes[vessel.id],
            })),
        })),
        categories: categories.map((categoryOption) => ({
            ...categoryOption,
            historicalVolume: calculation?.categoryVolumes[categoryOption.id],
        })),
    };
};
